import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

import { createOrderDetails, saveAuditLogs, updateOrderDetails } from "../../../services/studentService";
const initialState = {
    order: {
        orderDetails: {},
        status: "idle",
        error: null,
        updateStatus: "idle",
    },
    updatePaymentDetails: {
        status: "idle",
        data: {},
        error: null
    },
    auditLogDetails:{
        status: "idle",
        data: {},
        error: null
    },
    buttonToggle: true

};

export const apiCreateOrderID = createAsyncThunk(
    "payment/status",
    async (data) => {
        console.log("iam in slice")
        const response = await createOrderDetails(data);
        return response;
    }
);

export const apiUpdateOrderDetails = createAsyncThunk(
    "payment/update-order-details",
    async (data) => {
        const response = await updateOrderDetails(data);
        return response;
    }
);

export const apiSaveAuditLogs = createAsyncThunk(
    "payment/saveAuditLogs",
    async (data) => {
        const response = await saveAuditLogs(data);
        return response
    }
)
export const paymentOrderSlice = createSlice({
    name: "paymentStatus",
    initialState,
    reducers: {
        paymentButtonIsShown: (state, action) => {
            state.buttonToggle = action.payload
        },
        resetCreateOrderState: (state) => {
            state.order = initialState.order
        },
        resetPaymentStatusSliceState : (state) => {
            state.updatePaymentDetails.data = {}
        }
    },
    extraReducers: {
        [apiCreateOrderID.pending]: (state) => {
            state.order.status = "loading";
        },
        [apiCreateOrderID.fulfilled]: (state, action) => {
            if (action.payload.isDataAvailable) {
                state.order.status = "succeeded";
                state.order.orderDetails = action.payload.result;
            }else{
                state.order.status = "failed";
                state.order.error = action.payload.error;
            }
        },
        [apiCreateOrderID.rejected]: (state, action) => {
            state.order.status = "failed";
        },
        [apiUpdateOrderDetails.pending]: (state) => {
            state.updatePaymentDetails.status = "loading";
        },
        [apiUpdateOrderDetails.fulfilled]: (state, action) => {
            if (action.payload.isDataAvailable) {
                state.updatePaymentDetails.status = "succeeded";
                state.updatePaymentDetails.data = action.payload.result;
            }else{
                state.updatePaymentDetails.status = "failed"
                state.updatePaymentDetails.error = action.payload.error
            }
        },
        [apiUpdateOrderDetails.rejected]: (state, action) => {
            state.updatePaymentDetails.status = "failed";
        },
        [apiSaveAuditLogs.pending]: (state) => {
            state.auditLogDetails.status = "loading";
        },
        [apiSaveAuditLogs.fulfilled]: (state, action) => {
            if (action.payload) {
                state.auditLogDetails.status = "succeeded";
            }else{
                state.auditLogDetails.status = "failed"
            }
        },
        [apiSaveAuditLogs.rejected]: (state, action) => {
            state.auditLogDetails.status = "failed";
        }
    }
});

export const { paymentButtonIsShown, resetPaymentStatusSliceState, resetCreateOrderState} = paymentOrderSlice.actions

export default paymentOrderSlice.reducer;
